import React, { useState, useEffect } from 'react'
import PatientAccountService from '../../../../../services/api/patient-account.service'
import PatientAccountForm from '../patient-account-form/PatientAccountForm'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'
const PatientAccountEdit = (props) => {

    const [apiResponse, setApiResponse] = useState()
    const [isSubmitted, setIsSubmitted] = useState(false)
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const submitHandler = (type, data) => {
        setIsSubmitted(true)
        let reqObj = {
            "address": {
                "addressLine1": data.address.addressLine1 || null,
                "addressLine2": data.address?.addressLine2 || null,
                "city": data.address.city || null,
                "state": data.address.state || null,
                "country": data.address.state ? 1 : null,
                "postalCode": data.address.postalCode ? data.address.postalCode.toString() : null
            },
            "samePatientAddress": data.samePatientAddress === 1 ? true : false || false,
            "practiceLocationId": data.practiceLocationId,
            "accountType": type === "ach" ? 2 : 1,
        }
        if (type === "credit-debit") {
            reqObj.cardExpiry = data?.cardExpiry?.toString().includes("/") ? data?.cardExpiry?.toString().replace("/", "") : data?.cardExpiry.toString()
        }
        PatientAccountService.editPatientAccount(reqObj, props.patientId, props.account.id)
            .then(res => {
                setApiResponse(res)
            })
            .catch(err => {
                setApiResponse(err)
            })
            .finally(() => {
                setIsSubmitted(false)
            })

    }
    return (
        <>
            {isSubmitted ? <DimLoader loadMessage="Updating Account..." /> : null}
            <PatientAccountForm isEdit initialData={{ ...props.account, patientId: props.patientId }} onClose={() => props.onClose()} buttonLabel="Update" disableLocationEdit={true} submitHandler={submitHandler} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>

    )
}

export default PatientAccountEdit